var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 20,
    viewBox: "0 0 12.5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-location",
    "data-name": "Icon metro-location",
    d: "M14.6,1.928a6.25,6.25,0,0,0-6.25,6.25c0,6.25,6.25,13.75,6.25,13.75s6.25-7.5,6.25-13.75a6.25,6.25,0,0,0-6.25-6.25Zm0,10.078a3.828,3.828,0,1,1,3.828-3.828A3.828,3.828,0,0,1,14.6,12.006ZM12.183,8.178A2.422,2.422,0,1,1,14.6,10.6,2.422,2.422,0,0,1,12.183,8.178Z",
    transform: "translate(-8.355 -1.928)",
    fill: "#ee5959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.eae377670e86ffdfdcf6466f995d53f9.svg";
export { ForwardRef as ReactComponent };